import React, {useState, useEffect, useRef} from 'react'
import {GETPRODUCTLIST, DELETE_PRODUCT, CREATE_PRODUCT} from '../../../../utils/GraphQLAPI'
import {useLazyQuery, useMutation} from '@apollo/client'
import {AddProductModal} from './ProductModal/AddProductModal'
import plusIcon from '../../../../_metronic/images/smlplus.svg'
import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content'
import '../../../shared-css/Global.css'
import DownloadCsv from '../../Download/DownloadCsv'
import {alert} from '../../../../utils/helper'
import SearchList from '../../../sharedComponent/SearchList/SearchList'
import {
  PRODUCTLISTCONFIGS,
  filterDataFeedHelper,
  productFilterDataFeed,
} from '../../../../utils/TeamAdmin/ProductUtils'
import {dropdownMenuItemsType} from '../../../sharedComponent/SearchList/SearchList.types'
import {filterConfig} from '../../../../utils/Global.types'
import {GLOBAL_CONSTANTS} from '../../../../utils/GlobalConstants'
import {getProductDetailResponse} from '../../../../utils/GlobalAPI.types'
import Filter from '../../../sharedComponent/Filter'
import {useNavigate, useParams} from 'react-router-dom'

import UploadProducts from './UploadProducts'
const MySwal = withReactContent(Swal)
// Product Download
const csvHeaders = [
  {label: 'Product Name', key: 'productName'},
  {label: 'Commodity', key: 'commodityType'},
  {label: 'Customer Type', key: 'customerType'},
  {label: 'Brand', key: 'brand'},
  {label: 'Product Code', key: 'productCode'},
  {label: 'Billing Method', key: 'billingMethod'},
  {label: 'Adder', key: 'adder'},
  {label: 'Contract Type', key: 'contractType'},
  {label: 'Deposit', key: 'deposit'},
  {label: 'Rate', key: 'rate'},
  {label: 'Second Rate', key: 'secondRate'},
  {label: 'Service Fee', key: 'serviceFee'},
  {label: 'Term', key: 'term'},
  {label: 'Termination Fee', key: 'terminationFee'},
  {label: 'Unit', key: 'unit'},
  {label: 'Utility', key: 'utility'},
  {label: 'Start Date', key: 'startDate'},
  {label: 'End Date', key: 'endDate'},
  {label: 'Product Status', key: 'isActive'},
  {label: 'Note 1', key: 'productNotes[0]'},
  {label: 'TPV Script', key: 'tpvScriptStatus'},
]
const productInitialFilter = {
  page: 1,
  perPage: 10,
  searchText: '',
  isActive: null,
  tpvScriptStatus: null,
  utilityId: null,
  contractTypeId: null,
  customerTypeId: null,
}
const ProductList = ({
  filterData,
  getProductSetup,
}: {
  filterData: getProductDetailResponse
  getProductSetup: any
}) => {
  const [createModal, setCreateModal] = useState<string>('create')
  const [showCreateAppModal, setShowCreateAppModal] = useState<boolean>(false)
  const [productId, setProductId] = useState<any>()
  const [downloadData, setDownloadData] = useState<any>([])
  const [filterFeed, setFilterFeed] = useState<filterConfig[]>([])
  const [filterTempOptions, setFilterTempOptions] = useState<any>()

  const csvRef = useRef<any>(null)
  console.log('fitlerLogs', filterData, filterFeed)
  const [filterOptions, setFilterOptions] = useState<any>(productInitialFilter)
  const [getProductList, {loading, data: productList}] = useLazyQuery(GETPRODUCTLIST, {
    variables: {
      productListFilterInput: filterOptions,
    },
    onError: (err) => console.log('error', err),
    fetchPolicy: GLOBAL_CONSTANTS.networkOnly,
  })
  const getUrlParams = useParams()
  const navigate = useNavigate()
  useEffect(() => {
    if (filterData?.getProductDetail?.length) {
      let filterDataFromApi: productFilterDataFeed[] = filterData?.getProductDetail
        .filter(
          (value) =>
            value.enum === 'UTILITY' ||
            value.enum === 'CONTRACT_TYPE' ||
            value.enum === 'CUSTOMER_TYPE'
        )
        .map((value) => ({
          enum: value.enum,
          names: value.names.map(({id, value}) => ({id: id, value: value})),
        }))
      let filterDataTemp: productFilterDataFeed[] = [
        ...filterDataFromApi,
        {
          enum: 'TPV_STATUS',
          names: [
            {
              id: 'ASSIGNED',
              value: 'Assigned',
            },
            {
              id: 'UNASSIGNED',
              value: 'Unassigned',
            },
          ],
        },
        {
          enum: 'PRODUCT_STATUS',
          names: [
            {
              id: GLOBAL_CONSTANTS.filterBooleanValue.true,
              value: 'Active',
            },
            {
              id: GLOBAL_CONSTANTS.filterBooleanValue.false,
              value: 'Inactive',
            },
          ],
        },
      ]
      setFilterFeed(() =>
        filterDataTemp.map((value) => filterDataFeedHelper(value.names, value.enum))
      )
    }
  }, [filterData])
  useEffect(() => {
    getProductList()
  }, [filterOptions])

  //Delete product
  const [deleteProduct] = useMutation(DELETE_PRODUCT, {
    onCompleted: (data) => {
      alert(data.removeProduct, 'success')
      getProductList()
    },
    onError: (err) => alert(err.message, 'error'),
    fetchPolicy: 'network-only',
  })
  const removePageProperties = (filterOptions: any) => {
    const {page, perPage, ...rest} = filterOptions
    return rest
  }
  // Product Download API  Hit
  const [getProductCSVList, {loading: reload}] = useLazyQuery(GETPRODUCTLIST, {
    fetchPolicy: GLOBAL_CONSTANTS.networkOnly,
    variables: {
      productListFilterInput: removePageProperties(filterOptions),
      withDual: true,
    },
    onCompleted: async (data) => {
      const res = await data.getProductListByTeamAdmin.products
      setDownloadData(
        res.map((product: any) => ({
          ...product,
          isActive: product.isActive ? 'Active' : 'Inactive',
        }))
      )
    },
    onError: (err) => console.log('error', err),
  })

  const openModal = (id: any, type?: string) => {
    console.log('id and type', id, type)
    const fetchedItems: any = []
    filterData?.getProductDetail
      ?.filter((item: any) => item.enum !== 'COMMODITY' && item.enum !== 'CUSTOMER_TYPE')
      .forEach((item: any) => {
        item.names.forEach((data: any) => fetchedItems.push(data))
      })

    if (fetchedItems === undefined || fetchedItems.length === 0) {
      MySwal.fire({
        icon: 'warning',
        title: 'Please Complete Product Setup before Adding a Product',
      })
    } else {
      setShowCreateAppModal(true)
      if (type === 'edit') {
        setCreateModal('edit')
        setProductId(id)
      } else if (type === 'Create') {
        setCreateModal(type)
        setProductId('')
      } else if (type === 'clone') {
        setCreateModal('clone')
        setProductId(id)
      }
    }
  }

  const handleCloseModal = () => {
    setShowCreateAppModal(false)
    setProductId('')
  }

  const csvDownloadFun = async () => {
    await getProductCSVList()
    if (csvRef.current) {
      csvRef.current.link.click()
    }
  }
  const openAudit = (id: any) => {
    navigate(`/${getUrlParams.adminUser}/product-audit`, {
      state: {
        itemId: id,
        itemType: 'Product',
      },
    })
  }

  const dropdownMenuItems: dropdownMenuItemsType[] = [
    {
      name: 'Edit',
      callBack: openModal,
    },
    {
      name: 'Clone',
      callBack: openModal,
    },

    {
      name: 'Audit',
      callBack: openAudit,
    },
    {
      name: 'Delete',
      callBack: (id) =>
        deleteProduct({
          variables: {
            prodId: id,
          },
        }),
      textColor: 'text-danger',
    },
  ]
  //uploadproducts
  const [showUploadModal, setShowUploadModal] = useState(false)
  return (
    <SearchList
      filterOptions={filterOptions}
      setFilterOptions={setFilterOptions}
      apiData={productList?.getProductListByTeamAdmin?.products}
      listLoading={loading}
      listCount={productList?.getProductListByTeamAdmin?.totalCount}
      paginatedCount={productList?.getProductListByTeamAdmin?.product?.length}
      listConfigs={PRODUCTLISTCONFIGS}
      idFieldName='prodId'
      isActiveApiFieldName=''
      dropdownMenuItems={dropdownMenuItems}
      onRowClick={(value: any) => openModal(value.prodId, 'edit')}
      toolbar={
        <>
          <UploadProducts
            showModal={showUploadModal}
            setShowModal={setShowUploadModal}
            refetchProduct={getProductList}
          />
          {productList?.getProductListByTeamAdmin?.totalCount !== 0 && (
            <DownloadCsv
              csvDownloadFun={csvDownloadFun}
              reload={reload}
              csvHeaders={csvHeaders}
              csvRef={csvRef}
              downloadData={downloadData}
              downloadFileName='Products.csv'
            />
          )}
          <Filter
            filterOptions={filterOptions}
            setFilterOptions={setFilterOptions}
            filterConfig={filterFeed}
            initialFilter={productInitialFilter}
          />
          <button
            className='btn btn-primary fs-6 px-5 py-3 ms-5'
            onClick={(e) => openModal('', 'Create')}
          >
            <img src={plusIcon} alt='' className='svg-icon svg-icon-1' />
            <span>Add Product</span>
          </button>

          {
            <AddProductModal
              show={showCreateAppModal}
              handleClose={handleCloseModal}
              method={createModal}
              editId={productId}
              refetchProduct={getProductList}
            />
          }
        </>
      }
    />
  )
}
export default ProductList
